import React, { useState } from "react";

import { Tabs, Tab, Row, Col } from "react-bootstrap";
import Summary from "./Summary";
import Trades from "./Trades";

const BotPerformance = (props) => {
  const { baseCoin, quoteCoin, strategy,t } = props;
  const lowerCaseStrategy = (strategy && strategy.toLowerCase()) || "long";
  const [activeTab, setActiveTab] = useState(0);
  const tabTitles = [t("summary"), t("trades")];
  const tabHeaders = tabTitles.map((item, index) => {
    return (
      <Col xs={2} key={index}>
        <a
          onClick={() => setActiveTab(index)}
          className={index == activeTab ? "tab-active" : "tab-inactive"}
        >
          {item}
        </a>
      </Col>
    );
  });
  const tabs = [
    <Summary baseCoin={ quoteCoin} t={t}/>,
    <Trades
      baseCoin={quoteCoin || "USD"}
      quoteCoin={baseCoin || ""}
      isLong={lowerCaseStrategy == "long"}
      t={t}
    />,
  ];
  return (
    <>
      <Row>{tabHeaders}</Row>
      {tabs[activeTab]}
    </>
  );
};

export default BotPerformance;
